import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {classify} from 'src/utils/classify';
import css from './markdown.css';


type ReactMarkdownComponents = React.ComponentProps<
  typeof ReactMarkdown
>['components'];

export type MarkdownProps = {
  /** Raw markdown source to render. */
  children: string;
  /** Extra classes for the wrapper — use for per-use-case layout (padding, height, overflow). */
  className?: string;
  /** Override element renderers when a use case needs custom output. */
  components?: ReactMarkdownComponents;
};

/**
 * Shared markdown renderer. Owns the GFM plugin and the canonical markdown
 * styling so chat, asset previews and inline assets render identically.
 * Customize per use case via `className` (layout) or `components` (renderers).
 */
export function Markdown({children, className, components}: MarkdownProps) {
  return (
    <div className={classify(css.markdown, className)}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
